import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ReadMore from 'srcReact/components/common2/ReadMore'

function Description({ feed }) {
  const { t } = useTranslation()
  const [descriptionText, setDescriptionText] = useState('')
  useEffect(() => {
    if (feed) {
      const parser = new DOMParser()
      const htmlText = feed && feed.message
      let feedMessage = parser?.parseFromString(htmlText, 'text/html')
      let element = null
      let type = ''
      if (feed.newsfeed_template === 'mixr_creation') {
        type = t('global.mixr')
        element = feedMessage?.querySelector('[class*="mixrCardWrapperSpecial__description"]')
      } else if (feed.newsfeed_template === 'group_creation') {
        type = t('global.group')
        element = feedMessage?.querySelector('[class*="gcard__description"]')
      }
      if (element) {
        if (type) {
          const divInElement = element.querySelector('div')
          const aboutTextTitle = `<b>${t('global.aboutGroupMixr', { type })}: </b>`
          divInElement?.insertAdjacentHTML('afterbegin', aboutTextTitle)
        }
        // remove empty lines (div with only br tag) from start and end of the message
        const childDivs = element.childNodes
        if (childDivs) {
          const arrayChildDivs = [...childDivs]
          //get only div elements
          const arrayMessageDivs = arrayChildDivs.filter((div) => div.tagName === 'DIV')
          //hear we are not checking staring div (like standard message), because first div will always be prepended with text "About this group/mixr"
          while (
            arrayMessageDivs.length > 0 &&
            arrayMessageDivs[arrayMessageDivs.length - 1].innerHTML?.trim() === '<br>'
          ) {
            arrayMessageDivs.pop()
          }
          setDescriptionText(arrayMessageDivs.map((div) => div.outerHTML).join(''))
        }
      }
    }
  }, [feed])

  return (
    <ReadMore showMoreText={t('global.seeMore')} showLessText={t('global.seeLess')}>
      {descriptionText}
    </ReadMore>
  )
}

export default Description
